<template>
  <div>
    <a-drawer :title="permissionId ? '修改权限' : '添加权限'" :width="720" :visible="visible" :body-style="{ paddingBottom: '80px' }" :mask-closable="false" @close="onClose">
      <a-form-model ref="form" :rules="rules" :model="form" layout="vertical">
        <a-row>
          <a-form-model-item label="权限类型" prop="permission_type">
            <a-radio-group v-model="form.permission_type" button-style="solid">
              <a-radio-button v-for="(item, key) in permissionTypes" :key="key" :value="item.value"> {{ item.label }} </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="父级权限" prop="parent_id">
            <a-tree-select v-if="permissionOptions" v-model="form.parent_id" :replace-fields="replaceFields" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择所属菜单" :tree-data="permissionOptions" tree-default-expand-all @change="handleParentChange" />
          </a-form-model-item>
        </a-row>
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-model-item label="权限名称" prop="name">
              <a-input v-model="form.name" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="权限Code" prop="code">
              <a-input v-model="form.code" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="路径">
              <a-input v-model="form.route" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="权限排序">
              <a-input-number v-model="form.sort" style="width: 100%" :min="1" :max="100000" :default-value="1" />
            </a-form-model-item>
          </a-col>
          <a-col v-if="form.permission_type === 1" :span="12">
            <a-form-model-item label="组件">
              <a-input v-model="form.component" />
            </a-form-model-item>
          </a-col>
          <a-col v-if="form.permission_type === 1" :span="12">
            <a-form-model-item label="重定向">
              <a-input v-model="form.redirect" />
            </a-form-model-item>
          </a-col>
          <a-col v-if="form.permission_type === 1" :span="12">
            <a-form-model-item label="图标">
              <a-input v-model="form.icon" />
            </a-form-model-item>
          </a-col>
          <a-col v-if="form.permission_type === 1" :span="12">
            <a-form-model-item label="是否隐藏">
              <a-radio-group v-model="form.hide" button-style="solid">
                <a-radio-button :value="1"> 是 </a-radio-button>
                <a-radio-button :value="0"> 否 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item label="备注信息">
          <a-textarea v-model="form.description" :rows="2" placeholder="请输入备注信息" />
        </a-form-model-item>
      </a-form-model>
      <div
        :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1
        }"
      >
        <a-button :style="{ marginRight: '8px' }" @click="onClose"> 取消 </a-button>
        <a-button type="primary" @click="onSubmit"> 提交 </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { permissionTypes } from '@/utils/dictionary';
import { permissionModify, permissionAdd, permissionList } from '@/api/system/auth';
export default {
  props: {
    permissionId: {
      type: [Number, String],
      default: null
    },
    permissionData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {},
      initForm: {
        name: null,
        code: null,
        hide: 0,
        icon: '',
        route: '',
        sort: 1,
        component: '',
        redirect: '',
        parent_id: null,
        description: '',
        permission_type: 1
      },
      visible: false,
      permissionTypes,
      replaceFields: { children: 'children', title: 'name', key: 'id', value: 'id' },
      permissionOptions: [],
      rules: {
        name: [{ required: true, message: '权限名称不能为空', trigger: 'blur' }],
        code: [{ required: true, message: '权限Code不能为空', trigger: 'blur' }],
        parent_id: [{ required: true, message: '父级权限不能为空', trigger: 'blur' }],
        permission_type: [{ required: true, message: '权限类型不能为空', trigger: 'blur' }]
      }
    };
  },
  watch: {
    isShow() {
      this.visible = this.isShow;
      if (this.visible === true) {
        this.getPermissionList();
        if (this.permissionId) {
          this.form = {
            name: this.permissionData.name,
            code: this.permissionData.code,
            hide: this.permissionData.hide,
            icon: this.permissionData.icon,
            route: this.permissionData.route,
            sort: this.permissionData.sort,
            component: this.permissionData.component,
            redirect: this.permissionData.redirect,
            parent_id: this.permissionData.parent_id,
            description: this.permissionData.description,
            permission_type: this.permissionData.permission_type
          };
        } else {
          this.form = { ...this.initForm };
        }
      }
    }
  },

  methods: {
    onClose() {
      this.form = {};
      this.$refs.form.resetFields();
      this.$emit('close');
    },

    getPermissionList() {
      permissionList({ permission_type: 1 })
        .then(res => {
          this.permissionOptions = [
            {
              id: 0,
              name: '根节点',
              children: res.data.items
            }
          ];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handleParentChange() {
      this.$refs.form.validateField(['parent_id'], valid => {
        if (valid === '') {
          if (this.permissionId && this.form.parent_id === this.permissionId) {
            this.$message.warning('不能选择自己');
            this.form.parent_id = null;
          }
        }
      });
    },

    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.permissionId) {
            permissionModify({ ...this.form, id: this.permissionId })
              .then(() => {
                this.$message.success('修改成功');
                this.onClose();
              })
              .catch(() => {
                this.loading = false;
              });
          } else {
            permissionAdd(this.form)
              .then(() => {
                this.$message.success('添加成功');
                this.onClose();
              })
              .catch(() => {
                this.loading = false;
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
